module.exports = __webpack_public_path__ + "img/w1_2.ac53a56f.png";